import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <p>contact us: drawsula@gmail.com</p>
    </footer>
  );
}

export default Footer;
